import React, { useState, useRef, useEffect } from "react";
import DeleteModal from "./DeleteModal";

const groupMessages = [
  { id: 1, text: "Dodji!", from: "Marija", time: "02:42 PM" },
  {
    id: 2,
    text: "Location Pin: Van Zone (Club) https://vanzone.club/place/van-zone-44.8125_20.4581",
    from: "Marija",
    time: "02:42 PM",
  },
];

const groupMessages2 = [
  { id: 1, text: "Dodji!", from: "Marija", time: "02:42 PM" },
  {
    id: 2,
    text: "Location Pin: Van Zone (Club) https://vanzone.club/place/van-zone-44.8125_20.4581",
    from: "Marija",
    time: "02:42 PM",
  },
  {
    id: 3,
    text: "Izvinite, neki drugi put. Uzivajte!",
    from: "me",
    time: "02:45 PM",
  },
  {
    id: 4,
    text: "Kad smo rekli veceras? Za sat se nalazimo?",
    from: "Nenad",
    time: "06:45 PM",
  },
  { id: 5, text: "Da. 😊", from: "Marija", time: "06:46 PM" },
  {
    id: 6,
    text: "Je l stvarno dolazi Stefan?",
    from: "Zorana",
    time: "06:47 PM",
  },
  {
    id: 7,
    text: "Veceras ce stvarno upoznati svoje zaposlene. 😈",
    from: "Vuk-Janko",
    time: "06:47 PM",
  },
  { id: 8, text: "😂", from: "Marija", time: "06:48 PM" },
  { id: 9, text: "😅", from: "Zorana", time: "06:48 PM" },
  {
    id: 10,
    text: "Sve ce se saznati veceras. 😈",
    from: "Vuk-Janko",
    time: "06:49 PM",
  },
];

const privateMessages = [
  { id: 1, text: "Izvini, greska", from: "me", time: "00:42 AM" },
  { id: 2, text: "Zasto si mi poslao ovo?", from: "Marija", time: "00:44 AM" },
];

const privateMessages2 = [
  { id: 1, text: "Izvini, greska", from: "me", time: "00:42 AM" },
  { id: 2, text: "Zasto si mi poslao ovo?", from: "Marija", time: "00:44 AM" },
  {
    id: 3,
    text: "Sto mi saljes ovako kasno?",
    from: "Marija",
    time: "00:45 AM",
  },
];

const privateMessages3 = [
  { id: 1, text: "Izvini, greska", from: "me", time: "00:42 AM" },
  { id: 2, text: "Zasto si mi poslao ovo?", from: "Marija", time: "00:44 AM" },
  {
    id: 3,
    text: "Sto mi saljes ovako kasno?",
    from: "Marija",
    time: "00:45 AM",
  },
  { id: 4, text: "Koja si ti budala!", from: "Marija", time: "00:46 AM" },
];

const privateMessages4 = [
  { id: 1, text: "Izvini, greska", from: "me", time: "00:42 AM" },
  { id: 2, text: "Zasto si mi poslao ovo?", from: "Marija", time: "00:44 AM" },
  {
    id: 3,
    text: "Sto mi saljes ovako kasno?",
    from: "Marija",
    time: "00:45 AM",
  },
  { id: 4, text: "Koja si ti budala!", from: "Marija", time: "00:46 AM" },
  { id: 5, text: "NE DOLAZIS?", from: "Marija", time: "00:47 AM" },
];

const privateMessages5 = [
  { id: 1, text: "Izvini, greska", from: "me", time: "00:42 AM" },
  { id: 2, text: "Zasto si mi poslao ovo?", from: "Marija", time: "00:44 AM" },
  {
    id: 3,
    text: "Sto mi saljes ovako kasno?",
    from: "Marija",
    time: "00:45 AM",
  },
  { id: 4, text: "Koja si ti budala!", from: "Marija", time: "00:46 AM" },
  { id: 5, text: "NE DOLAZIS?", from: "Marija", time: "00:47 AM" },
  { id: 6, text: "IZNERVIRAO SI ME!", from: "Marija", time: "00:48 AM" },
];

const privateMessages6 = [
  { id: 1, text: "Izvini, greska", from: "me", time: "00:42 AM" },
  { id: 2, text: "Zasto si mi poslao ovo?", from: "Marija", time: "00:44 AM" },
  {
    id: 3,
    text: "Sto mi saljes ovako kasno?",
    from: "Marija",
    time: "00:45 AM",
  },
  { id: 4, text: "Koja si ti budala!", from: "Marija", time: "00:46 AM" },
  { id: 5, text: "NE DOLAZIS?", from: "Marija", time: "00:47 AM" },
  { id: 6, text: "IZNERVIRAO SI ME!", from: "Marija", time: "00:48 AM" },
  { id: 7, text: "UZASAN SI!", from: "Marija", time: "00:49 AM" },
];

const privateMessages7 = [
  { id: 1, text: "Izvini, greska", from: "me", time: "00:42 AM" },
  {
    id: 2,
    text: "Ma opusteno. Je l dolazis na orijentaciju danas u 14h?",
    from: "Marija",
    time: "9:44 AM",
  },
];

const privateMessages8 = [
  { id: 1, text: "Izvini, greska", from: "me", time: "00:42 AM" },
  {
    id: 2,
    text: "Ma opusteno. Je l dolazis na orijentaciju danas u 14h?",
    from: "Marija",
    time: "9:44 AM",
  },
  {
    id: 3,
    text: "Da, naravno.",
    from: "me",
    time: "9:50 AM",
  },
  {
    id: 4,
    text: "Super! Vidimo se! 😊",
    from: "Marija",
    time: "9:55 AM",
  },
];

const privateMessages9 = [
  { id: 1, text: "Izvini, greska", from: "me", time: "00:42 AM" },
  {
    id: 2,
    text: "Ma opusteno. Je l dolazis na orijentaciju danas u 14h?",
    from: "Marija",
    time: "9:44 AM",
  },
  {
    id: 3,
    text: "Da, naravno.",
    from: "me",
    time: "9:50 AM",
  },
  {
    id: 4,
    text: "Super! Vidimo se! 😊",
    from: "Marija",
    time: "9:55 AM",
  },
  {
    id: 5,
    text: "Izvini sto nisam dosao. Kako je proslo?",
    from: "me",
    time: "15:30 PM",
  },
  {
    id: 6,
    text: "Opusteno. Bilo je super!",
    from: "Marija",
    time: "15:35 PM",
  },
];

export default function Chat({ chatType, onChangeChat }) {
  const [showModal, setShowModal] = useState(false);
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const [selectedMsg, setSelectedMsg] = useState(null);

  const bodyRef = useRef(null);
  const inputRef = useRef(null);
  const marijaRepliedRef = useRef(false);
  const marijaTimerRef = useRef(null);
  const sentCountRef = useRef(0);

  useEffect(() => {
    marijaRepliedRef.current = false;
    sentCountRef.current = 0;
    return () => clearTimeout(marijaTimerRef.current);
  }, [chatType]);

  const scrollToBottom = () => {
    if (bodyRef.current) {
      bodyRef.current.scrollTop = bodyRef.current.scrollHeight;
    }
  };

  useEffect(() => {
    let messages = privateMessages;
    if (chatType === "private1") {
      messages = privateMessages;
    } else if (chatType === "group1") {
      messages = groupMessages;
    } else if (chatType === "group2") {
      messages = groupMessages2;
    } else if (chatType === "private2") {
      messages = privateMessages2;
    } else if (chatType === "private3") {
      messages = privateMessages3;
    } else if (chatType === "private4") {
      messages = privateMessages4;
    } else if (chatType === "private5") {
      messages = privateMessages5;
    } else if (chatType === "private6") {
      messages = privateMessages6;
    } else if (chatType === "private7") {
      messages = privateMessages7;
    } else if (chatType === "private8") {
      messages = privateMessages8;
    } else if (chatType === "private9") {
      messages = privateMessages9;
    }
    setMessages(messages);
  }, [chatType]);

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  const handleSend = () => {
    if (!input.trim()) return;

    let time;
    if (chatType === "private9") {
      sentCountRef.current += 1;
      if (sentCountRef.current === 1) time = "17:22 PM";
      else if (sentCountRef.current === 2) time = "17:23 PM";
      else time = new Date().toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit", hour12: true });
    } else {
      time = new Date().toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit", hour12: true });
    }

    setMessages((prev) => [
      ...prev,
      { from: "me", id: Date.now(), text: input, time },
    ]);

    setInput("");

    if (chatType === "private9" && !marijaRepliedRef.current) {
      marijaRepliedRef.current = true;
      marijaTimerRef.current = setTimeout(() => {
        setMessages((prev) => [
          ...prev,
          {
            id: Date.now(),
            from: "Marija",
            text: "Bice svake nedelje. Javljam uskoro na grupi! 😊",
            time: "17:23 PM",
          },
        ]);
      }, 5000);
    }
  };

  const handleDelete = () => {
    setMessages(messages.filter((m) => m.id !== selectedMsg.id));
    setShowModal(false);
  };

  return (
    <div className="chat-app">
      <div className="chat-header">
        <span
          className="material-symbols-outlined"
          onClick={() => onChangeChat("all")}
        >
          arrow_back
        </span>
        <span className="chat-name">
          {chatType.includes("group") ? "Group" : "Marija"}
        </span>
        <div className="icon-item">
          <span className="material-icons-outlined">video_camera_back</span>
          <span className="material-symbols-outlined">call</span>
          <span className="material-symbols-outlined">more_horiz</span>
        </div>
      </div>

      <div className="chat-body" ref={bodyRef}>
        <div className="date-divider">Yesterday</div>

        {messages.map((msg, index) => {
          const { from, id, text, time } = msg;

          let msgFromMe = "";
          let msgFromOther = "";

          if (chatType.includes("group") && from !== "me") {
            msgFromOther = from;
          }

          if (from === "me") {
            msgFromMe = "Me";
          }

          if (messages[index - 1] && messages[index - 1].from === from) {
            msgFromMe = "";
            msgFromOther = "";
          }

          return (
            <div
              key={id}
              className={`message-wrapper ${
                from === "me" ? "sent" : "received"
              }`}
            >
              {msgFromOther && (
                <span className="sender-other">{msgFromOther}</span>
              )}

              {msgFromMe && <span className="sender-me">{msgFromMe}</span>}

              <div className={`message ${from === "me" ? "sent" : "received"}`}>
                <p
                  onClick={() => {
                    setSelectedMsg(msg);
                    setShowModal(true);
                  }}
                >
                  {text}
                </p>
              </div>
              <span className="time">{time}</span>
            </div>
          );
        })}
      </div>

      <div className="chat-input">
        <div className="input-wrapper">
          <input
            ref={inputRef}
            type="text"
            value={input}
            onChange={(e) => setInput(e.target.value)}
          />
          {!input && <span className="placeholder">Write your message...</span>}
        </div>
        <button onClick={handleSend}>➤</button>
      </div>
      <div className="line"></div>

      <DeleteModal
        show={showModal !== false}
        onCancel={() => setShowModal(false)}
        onDelete={() => handleDelete(showModal)}
      />
    </div>
  );
}
